import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import MenuLateral from '../Components/MenuLateral';
import Navbar from '../Components/Navbar/navbar';
import Footer from "../Components/Footer";
import api from '../../services/api';

import './index.css';

const Index = () => {
    const navigate = useNavigate();
    const { conteudoID } = useParams();

    const [conteudo, setConteudo] = useState(null);
    const [arquivos, setArquivos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const buscaArquivos = async () => {
            try {
                setLoading(true);
                const responseConteudo = await api.get(`/conteudos/${conteudoID}`);
                setConteudo(responseConteudo.data);

                const responseArquivos = await api.get(`/arquivos/conteudo/${conteudoID}`);
                setArquivos(responseArquivos.data);
            } catch (error) {
                console.error("Erro ao buscar conteúdo ou arquivos:", error);
                navigate('/Treinamentos');
            } finally {
                setLoading(false);
            }
        };
        buscaArquivos();
    }, [conteudoID, navigate]);

    if (loading) return <p>Carregando conteúdo...</p>;
    if (!conteudo) return <p>Conteúdo não encontrado.</p>;

    return (
        <div className='conteudo-background'>
            <Navbar />
            <div className="conteudo-wrapper">
                <MenuLateral title={conteudo.titulo} conteudo={conteudo} arquivos={arquivos} loading={loading} />
                {/* <div className="col-sm-9" style={{ padding: '1em' }}> */}
                <div className="visualizador-container">
                    <Outlet />
                </div>
                {/* </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default Index;
